import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import PostExcelRequestModel from '../../../../services/v2/model/post-excel-request-model';

export default class MeasurementsPage extends PageBase {
  public sensorMeasurementsDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.sensorMeasurements.getSensorMeasurements,
    insertCommand: Vue.$service.v2.api.sensorMeasurements.postExcel,
  });

  public customersDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.sensorMeasurements.getCustomers,
  });

  public projectsDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.sensorMeasurements.getProjects,
  });

  public sensorIdsDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.sensorMeasurements.getSensorIds,
  });

  public sensorTypesDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.sensorMeasurements.getSensorTypes,
  });

  public sensorConfigsDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.sensorMeasurements.getSensorConfigs,
  });

  public isLoadingExcel = false;

  public get sensorMeasurementsList() {
    return this.sensorMeasurementsDataSource.data?.items.map((i) => {
      const data = { ...i.data };
      return {
        ...data,
        valueWithUnit1: `${(data.value1 != null && data.value1 !== 0) ? data.value1 : ''} ${data.unit1 ?? ''}`.trim(),
        valueWithUnit2: `${(data.value2 != null && data.value2 !== 0) ? data.value2 : ''} ${data.unit2 ?? ''}`.trim(),
      };
    }) || [];
  }

  public set sensorMeasurementsList(value) { /* Do nothing */ }

  public get customersList() {
    return this.customersDataSource.data?.items.map((c) => {
      const value = c.data;
      return {
        id: value,
        caption: value,
      };
    }) || [];
  }

  public set customersList(value) { /* Do nothing */ }

  public get projectsList() {
    return this.projectsDataSource.data?.items.map((c) => {
      const value = c.data;
      return {
        id: value,
        caption: value,
      };
    }) || [];
  }

  public set projectsList(value) { /* Do nothing */ }

  public get sensorIdsList() {
    return this.sensorIdsDataSource.data?.items.map((c) => {
      const value = c.data;
      return {
        id: value,
        caption: value,
      };
    }) || [];
  }

  public set sensorIdsList(value) { /* Do nothing */ }

  public get sensorTypesList() {
    return this.sensorTypesDataSource.data?.items.map((c) => {
      const value = c.data;
      return {
        id: value,
        caption: value,
      };
    }) || [];
  }

  public set sensorTypesList(value) { /* Do nothing */ }

  public get sensorConfigsList() {
    return this.sensorConfigsDataSource.data?.items.map((c) => {
      const value = c.data;
      return {
        id: value,
        caption: value,
      };
    }) || [];
  }

  public set sensorConfigsList(value) { /* Do nothing */ }

  public measurementsColumns = [
    { value: Vue.$t('page.measurements.table.id'), textAlign: 'left', field: 'id' },
    { value: Vue.$t('page.measurements.table.customer'), textAlign: 'left', field: 'customer' },
    { value: Vue.$t('page.measurements.table.project'), textAlign: 'left', field: 'project' },
    { value: Vue.$t('page.measurements.table.object'), textAlign: 'left', field: 'object' },
    { value: Vue.$t('page.measurements.table.sensorId'), textAlign: 'left', field: 'sensorId' },
    { value: Vue.$t('page.measurements.table.sensorTyp'), textAlign: 'left', field: 'sensorTyp' },
    { value: Vue.$t('page.measurements.table.sensorConfig'), textAlign: 'left', field: 'sensorConfig' },
    { value: Vue.$t('page.measurements.table.valueUnit1'), textAlign: 'left', field: 'valueWithUnit1' },
    { value: Vue.$t('page.measurements.table.valueUnit2'), textAlign: 'left', field: 'valueWithUnit2' },
    { value: Vue.$t('page.measurements.table.measurementTime'), textAlign: 'left', field: 'measurementTime' },
  ];

  async initialize(): Promise<void> {
    await this.refreshMeasurements();
  }

  async refreshMeasurements() {
    try {
      await this.sensorMeasurementsDataSource.select();
      await this.customersDataSource.select();
      await this.projectsDataSource.select();
      await this.sensorIdsDataSource.select();
      await this.sensorTypesDataSource.select();
      await this.sensorConfigsDataSource.select();
    } catch (error) {
      Vue.$log.error(`Error refreshing measurements: ${error}`);
    }
  }

  public async downloadExcel() {
    this.isLoadingExcel = true;
    if (this.sensorMeasurementsDataSource.data) {
      if (this.sensorMeasurementsDataSource.data.items.length > 0) {
        const requestModel = new PostExcelRequestModel({
          searchCriteria: this.sensorMeasurementsDataSource.filter.searchCriteria,
          from: this.sensorMeasurementsDataSource.filter.from,
          until: this.sensorMeasurementsDataSource.filter.until,
          selectedCustomer: this.sensorMeasurementsDataSource.filter.selectedCustomer,
          selectedProject: this.sensorMeasurementsDataSource.filter.selectedProject,
          selectedSensorId: this.sensorMeasurementsDataSource.filter.selectedSensorId,
          selectedSensorTyp: this.sensorMeasurementsDataSource.filter.selectedSensorTyp,
          selectedSensorConfig: this.sensorMeasurementsDataSource.filter.selectedSensorConfig,
        });

        const response = await this.sensorMeasurementsDataSource.insert(requestModel);

        if (response && response.data) {
          const blob = new Blob([response.data], { type: 'application/excel' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'Sensor-Measurements.xlsx';
          link.click();
        }
      }
    }
    this.isLoadingExcel = false;
  }
}
